module.exports = __webpack_public_path__ + "static/img/11.c82872a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/11.png
// module id = cphl
// module chunks = 0